/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { NavLink } from 'react-router-dom';
import { Link, withRouter } from 'react-router-dom';
import CloseCaseIcon from 'Components/icons/CloseCaseIcon';
//import LockIcon from 'Assets/img/landingpage-lock.svg';

import './RecentCase.scss';

class RecentCase extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const isActive = this.props.location.pathname === this.props.route || this.props.location.pathname.includes(this.props.caseNumber);
    return (
      <span>
        <li id="case-item" className="recent-case-item">
          <Link
            to={this.props.route}
            className={isActive === true ? this.props.activeClassName : this.props.navActionClasses}
            id="item"
          >
            <svg viewBox="0 0 16 15" fill="none">
              <path d="M6.5 0.498474H9.5C9.89783 0.498474 10.2794 0.656509 10.5607 0.937814C10.842 1.21912 11 1.60065 11 1.99847V3.49847H14C14.3978 3.49847 14.7794 3.65651 15.0607 3.93781C15.342 4.21912 15.5 4.60065 15.5 4.99847V13.2485C15.5 13.6463 15.342 14.0278 15.0607 14.3091C14.7794 14.5904 14.3978 14.7485 14 14.7485H2C1.60218 14.7485 1.22064 14.5904 0.93934 14.3091C0.658035 14.0278 0.5 13.6463 0.5 13.2485V4.99847C0.5 4.60065 0.658035 4.21912 0.93934 3.93781C1.22064 3.65651 1.60218 3.49847 2 3.49847H5V1.99847C5 1.60065 5.15804 1.21912 5.43934 0.937814C5.72065 0.656509 6.10218 0.498474 6.5 0.498474V0.498474ZM9.5 3.49847V1.99847H6.5V3.49847H9.5Z" fill="currentColor" />
            </svg>
            {this.props.navLabel}
          </Link>
          <div
            className={isActive === true ? 'recent-case-close-active' : 'recent-case-close'}
            role="button"
            onClick={() => this.props.removeRecentCase(this.props.caseNumber)}
          >
            <CloseCaseIcon />
          </div>
        </li>
      </span>
    );
  }

}

RecentCase.propTypes = {
  forceIsActive: PropTypes.string,
  triggerSubNav: PropTypes.func,
  route: PropTypes.string,
  exact: PropTypes.bool,
  navActionClasses: PropTypes.string,
  activeClassName: PropTypes.string,
  iconClasses: PropTypes.string,
  labelClasses: PropTypes.string,
  icon: PropTypes.element,
  navLabel: PropTypes.any,
  hasNotification: PropTypes.bool,
  returnNotificationCount: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  returnCollapsedNotification: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  navItemKey: PropTypes.string,
};

RecentCase.defaultProps = {
  forceIsActive: '',
  triggerSubNav: () => { },
  route: '#',
  exact: false,
  activeClassName: 'vertical-nav-action vertical-nav-action-active',
  navActionClasses: 'vertical-nav-action',
  iconClasses: 'vertical-nav-icon',
  labelClasses: 'vertical-nav-label',
  icon: null,
  navLabel: false,
  hasNotification: false,
  returnNotificationCount: null,
  returnCollapsedNotification: null,
  navItemKey: '',
};

export default withRouter(RecentCase);
